import { render } from "./coach-request.vue?vue&type=template&id=42e1cfee"
import script from "./coach-request.vue?vue&type=script&lang=js"
export * from "./coach-request.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__